import React from 'react'
import PropTypes from 'prop-types'

import { ErrorPopover } from '../popover/error-popover'

const propTypes = {
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Error)]),
    formErrorContainerClassName: PropTypes.string
}

/**
 * A HOC to handle error popups for native input elements in t3-widgets Form components.
 * Please see the Advanced Form example.
 * @param {React.Component} InputElement
 * @return {React.Component}
 */
function withFormErrorHandling(InputElement) {
    const Wrapper = props => {
        const { error, formErrorContainerClassName } = props
        return (
            <div className={formErrorContainerClassName}>
                <ErrorPopover {...{ error }}>
                    <InputElement {...props} />
                </ErrorPopover>
            </div>
        )
    }
    Wrapper.propTypes = propTypes
    Wrapper.displayName = InputElement?.displayName || InputElement?.name || 'InputElement'
    return Wrapper
}

export { withFormErrorHandling }
